const SupportedOrder = () =>
  import(/* webpackChunkName: "supported" */ '@/pages/supported/order.vue')

export default {
  path: 'order',
  meta: {
    label: 'supportedOrder',
    auth: 'order'
  },
  component: {
    name: 'SupportedOrder',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'SupportedOrder',
      path: ':orderType',
      meta: {
        auth: 'report'
      },
      props: true,
      component: SupportedOrder
    }
  ]
}
